module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_06.70e3caf5.png";